import User from '@core/models/user/User';
import { getDeviceId } from '@src/config/idGenerationService';
import { getShellConfig } from '@src/config/shell/config';
import {
    ExperimentContext,
    ExperimentService,
    ExperimentServiceMarket,
} from '@superbet-group/web.types';

interface ExperimentServiceProps {
    user: User | null;
    isCheckedAuthentication: boolean;
    service: ExperimentService | null;
    timeoutMs?: number;
    setIsLoading: (isLoading: boolean) => void;
}

export async function loadExperimentService({
    user,
    isCheckedAuthentication,
    service,
    timeoutMs = 5000,
    setIsLoading,
}: ExperimentServiceProps) {
    if (!isCheckedAuthentication) {
        /*
        We have not yet decided if user is logged in or not
        so wait for now to avoid multiple calls for both
        logged out and then logged in once we discover
        potential login session
        */
        return;
    }

    if (!service) {
        // No api url provided so service is null
        return;
    }

    /*
    This will be ran every time the user logs in or logs
    out - that is expected!
    */
    const deviceId = getDeviceId();
    const playerId = user?.userUuid || user?.externalUUID;
    const shellConfig = getShellConfig();

    const context: ExperimentContext = playerId ? {
        deviceId,
        playerId,
        market: shellConfig.country as ExperimentServiceMarket,
    } : {
        deviceId,
    };

    /*
    The .initialize() call has try-catch and fail safe,
    and it will make sure that even if we provide
    the same context multiple times, it only evers
    does a new api request when the context changes
    */
    const didInitialize = await service.initialize(context, timeoutMs);

    if (didInitialize) {
        setIsLoading(false);
    }
}
